/* global alert:false */
import React, { Component } from 'react';
import { Row, Col, FormGroup, Label, Input, Button, FormFeedback } from 'reactstrap';
import { countries } from '../../helpers/countries';
import { allValid, validateName, validateEmail, validateCellphone, validateIdNumber } from '../../helpers/validation';
import { ageFromID, ageFromDateOfBirth } from '../../helpers/age';
import { genderFromId } from '../../helpers/gender';

class CreatePolicyholder extends Component {
  constructor (props) {
    super(props);
    this.state = {
      valid: {}
    };
  }

  updateField (path, value) {
    const data = this.props.data;
    path.reduce((acc, curr, i) => {
      if (i === path.length - 1) {
        acc[curr] = value;
        return true;
      } else {
        return acc[curr];
      }
    }, data);
    this.props.setData(data);
  }

  validate () {
    const policyholder = this.props.data.policyholder;
    const valid = {};

    valid.policyholder = {
      firstName: validateName(policyholder.firstName),
      lastName: validateName(policyholder.lastName),
      email: validateEmail(policyholder.email),
      cellphone: validateCellphone(policyholder.cellphone),
      id: {
        type: true, // assume only valid options
        country: true, // assumer only valid options
        number: policyholder.id.type === 'id'
          ? validateIdNumber(policyholder.id.number)
          : (policyholder.id.number && policyholder.id.number.length > 0)
      }
    };

    this.setState({ valid });

    return allValid(valid);
  }

  isValid (path) {
    const valid = this.state.valid;
    return !this.state.clicked || !!path.reduce((acc, curr) => acc && acc[curr], valid);
  }

  getValue (path) {
    const data = this.props.data;
    return path.reduce((acc, curr) => acc && acc[curr], data);
  }

  componentWillReceiveProps (props) {
    this.validate();
  }

  continue () {
    this.setState({ clicked: true });
    const isValid = this.validate();

    if (isValid) {
      const policyholder = this.props.data.policyholder;
      if (policyholder.id.type === 'id') {
        const policyholderAge = ageFromID(policyholder.id.number); // assume field exists
        const quoteAge = ageFromDateOfBirth(policyholder.dateOfBirth); // assume field exists
        if (policyholderAge !== quoteAge) {
          return alert('The policyholder\'s age does not match the quoted age. Please update the policyholder or retrieve a new quote.');
        }

        const policyholderGender = genderFromId(policyholder.id.number);
        const quoteGender = policyholder.gender;
        if (policyholderGender !== quoteGender) {
          return alert('The policyholder\'s gender does not match the quoted gender. Please update the policyholder or retrieve a new quote.');
        }
      }

      this.props.nextStep();
    }
  }

  render () {
    return <div>
      <h1>Policyholder</h1>
      <br />
      <h4>Please complete your details</h4>
      <br />

      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='firstName'>First name*</Label>
            <Input
              name='firstName'
              id='firstName'
              placeholder='Enter first name'
              invalid={!this.isValid(['policyholder', 'firstName'])}
              value={this.getValue(['policyholder', 'firstName'])}
              onChange={e => this.updateField(['policyholder', 'firstName'], e.target.value)}
            />
            <FormFeedback>Your first name is required</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label for='lastName'>Last name*</Label>
            <Input
              name='lastName'
              id='lastName'
              placeholder='Enter last name'
              invalid={!this.isValid(['policyholder', 'lastName'])}
              value={this.getValue(['policyholder', 'lastName'])}
              onChange={e => this.updateField(['policyholder', 'lastName'], e.target.value)}
            />
            <FormFeedback>Your last name is required</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='email'>Email address*</Label>
            <Input
              name='email'
              id='email'
              placeholder='Enter email address'
              invalid={!this.isValid(['policyholder', 'email'])}
              value={this.getValue(['policyholder', 'email'])}
              onChange={e => this.updateField(['policyholder', 'email'], e.target.value)}
            />
            <FormFeedback>A valid email address is required</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label for='cellphone'>Cellphone number*</Label>
            <Input
              name='cellphone'
              id='cellphone'
              placeholder='Enter cellphone number'
              invalid={!this.isValid(['policyholder', 'cellphone'])}
              value={this.getValue(['policyholder', 'cellphone'])}
              onChange={e => this.updateField(['policyholder', 'cellphone'], e.target.value)}
            />
            <FormFeedback>A valid cellphone number is required</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            <b>Type of identification</b>
          </p>
          <FormGroup>
            <FormGroup check inline>
              <Label check>
                <Input
                  type='radio'
                  name='radioID'
                  checked={this.getValue(['policyholder', 'id', 'type']) === 'id'}
                  onChange={() => {}}
                  onClick={e => {
                    this.updateField(['policyholder', 'id', 'type'], 'id');
                    this.updateField(['policyholder', 'id', 'country'], 'ZA');
                  }}
                />{' '}
              South African ID number
              </Label>
            </FormGroup>
            <FormGroup check inline>
              <Label check>
                <Input
                  type='radio'
                  name='radioPassport'
                  checked={this.getValue(['policyholder', 'id', 'type']) === 'passport'}
                  onChange={() => {}}
                  onClick={e => this.updateField(['policyholder', 'id', 'type'], 'passport')}
                />{' '}
              Passport number
              </Label>
            </FormGroup>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='idNumber'>{this.getValue(['policyholder', 'id', 'type']) === 'id' ? 'ID' : 'Passport'} number*</Label>
            <Input
              name='idNumber'
              id='idNumber'
              placeholder={'Enter ' + (this.getValue(['policyholder', 'id', 'type']) === 'id' ? 'ID' : 'passport') + ' number'}
              invalid={!this.isValid(['policyholder', 'id', 'number'])}
              value={this.getValue(['policyholder', 'id', 'number'])}
              onChange={e => this.updateField(['policyholder', 'id', 'number'], e.target.value)}
            />
            <FormFeedback>A valid {this.getValue(['policyholder', 'id', 'type']) === 'id' ? 'ID' : 'passport'} number is required</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label for='country'>Country*</Label>
            <Input
              type='select'
              name='country'
              id='country'
              disabled={this.getValue(['policyholder', 'id', 'type']) === 'id'}
              value={this.getValue(['policyholder', 'id', 'country']) || 'ZA'}
              onChange={e => this.updateField(['policyholder', 'id', 'country'], e.target.value)}
            >
              {countries.map(c => <option key={c.code} value={c.code}>{c.name}</option>)}
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <br />
      <br />
      <Button color='primary' className='px-5' onClick={this.continue.bind(this)}>Continue</Button>
      <Button color='link' onClick={this.props.previousStep}>Back</Button>
    </div>;
  }
}

export default CreatePolicyholder;



// WEBPACK FOOTER //
// ./src/components/application/create-policyholder.js